<div class="made-by-container">
  Powered by Krugo
</div>
